/*
 * @overview: api封装
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2024-04-27 15:30:09
 */

let domain = "";
export const initApi = `/zwsys/syspage/init`;
export const accessApi = `/zwsys/syspage/pageview`;

export function initHttp(opts) {
  domain = opts.projectAccessUrl;
}

/**
 * 获取初始路由配置
 */
export function getRouter() {
  return new Promise(function (resolve, reject) {
    ajax(`${window.location.origin}/pageRouter.json`, "GET", null, function (
      response
    ) {
      resolve(JSON.parse(response));
    });
  });
}

/**
 * 初始化项目信息
 */
export function initService(params = {}) {
  return new Promise(function (resolve, reject) {
    ajax(`${domain}${initApi}`, "POST", params, function (response) {
      resolve(JSON.parse(response));
    });
  });
}

/**
 * 访问上报
 */
export function accessService(params = {}) {
  return new Promise(function (resolve, reject) {
    ajax(`${domain}${accessApi}`, "POST", params, function (response) {
      resolve(JSON.parse(response));
    });
  });
}

/**
 * 封装原生ajax
 */
function ajax(url, method, data, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      callback(xhr.responseText);
    }
  };
  xhr.open(method, url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send(JSON.stringify(data));
}
